<template>
<div class="find-goods-info">
    <GoodsInfo></GoodsInfo>
</div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{

    },
    created(){
        document.title = '华诺威_汽配供应链专家';
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.find-goods-info{
    
}
</style>